import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

interface UseOuraRingReturn {
  isConnecting: boolean;
  isConnected: boolean;
  isLoading: boolean;
  connectToOuraRing: () => void;
  error: string | null;
}

export const useOuraRing = (): UseOuraRingReturn => {
  const [isConnecting, setIsConnecting] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ['oura', 'status'],
    queryFn: async () => {
      const response = await fetch('/api/oura/status');
      return response.json();
    },
  });

  const isConnected = data?.connected || false;

  const connectToOuraRing = () => {
    try {
      setIsConnecting(true);
      window.location.assign('/api/oura/authorize');
    } catch (err) {
      setIsConnecting(false);
      console.error('Oura Ring connection failed:', err);
    }
  };

  return {
    isConnecting,
    isConnected,
    isLoading,
    connectToOuraRing,
    error: error ? (error as Error).message || 'An error occurred' : null,
  };
};
